import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/goalsSagas";
import GoalsList from "../../../components/goalsList/goalsList";

const MembershipGoals = () => {
  const dispatch = useDispatch();
  const selectedView = useSelector((state) => state.goals.selectedView);
  const isCurrentMonth = useSelector((state) => state.goals.isCurrentMonth);
  const goalsLoading = useSelector((state) => state.goals.goalsLoading.memberships);
  const date = useSelector((state) => state.goals.date);
  const { membershipsTitle, memberships } = useSelector((state) => state.goals.goals);
  const { singleLocation, can_modify_goals } = useSelector((state) => state.goals.currentUser);

  return (
    <GoalsList
      isAnimated={false}
      listHeight={55}
      expandedHeight={115}
      goalLoading={goalsLoading}
      customClass="membershipGoals"
      title={membershipsTitle || "Membership"}
      goalData={memberships && memberships.length > 0 ? memberships : null}
      isCurrentMonth={isCurrentMonth}
      singleLocation={singleLocation}
      canModifyGoals={can_modify_goals}
      selectedView={selectedView.id}
      zIndex={9}
      date={date}
      saveGoal={(id, value, active) =>
        dispatch(
          actionCreators.updateGoal({
            id: id,
            value: value,
            active: active,
            goal_type: "memberships"
          })
        )
      }
      saveGoalAsValue={(id, value, active) =>
        dispatch(
          actionCreators.updateGoalAsValue({
            id: id,
            value: value || 0,
            active: active,
            goal_type: "memberships"
          })
        )
      }
    />
  );
};

export default MembershipGoals;
